<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="save()">
  <div class="wrapper--spacing-vertical">
    <div class="flex--column spacing--margin-bottom spacing--margin-top">
      <mat-label class="spacing--margin-half-bottom">
        {{ 'flock-overview.week-registrations.filters.labels.data-sources' | translate }}
      </mat-label>

      <mat-slide-toggle
        [hideIcon]="true"
        color="primary"
        class="text--small"
        [checked]="flockWeekChartFilters.showCurrentFlock"
        (change)="toggleShowValue('showCurrentFlock', flockWeekChartFilters.showCurrentFlock)"
        data-test="chart-settings__show-current-flock"
      >
        {{ 'flock-overview.week-registrations.filters.chart-lines.current-flock' | translate }}
      </mat-slide-toggle>

      <mat-slide-toggle
        [hideIcon]="true"
        color="primary"
        class="text--small spacing--margin-top"
        [checked]="flockWeekChartFilters.showBreedersReferenceBenchmark"
        (change)="
          toggleShowValue(
            'showBreedersReferenceBenchmark',
            flockWeekChartFilters.showBreedersReferenceBenchmark
          )
        "
        data-test="chart-settings__show-breeders-reference-benchmark"
      >
        {{
          'flock-overview.week-registrations.filters.chart-lines.breeders-reference-benchmark'
            | translate
        }}
      </mat-slide-toggle>

      <div class="spacing--margin-top">
        <mat-slide-toggle
          [hideIcon]="true"
          color="primary"
          class="text--small"
          [checked]="flockWeekChartFilters.showPorphyrioBenchmark && hasPorphyrioCategories"
          (change)="
            toggleShowValue('showPorphyrioBenchmark', flockWeekChartFilters.showPorphyrioBenchmark)
          "
          [disabled]="!hasPorphyrioCategories"
          data-test="chart-settings__show-porphyrio-benchmark"
        >
          {{
            'flock-overview.week-registrations.filters.chart-lines.porphyrio-benchmark' | translate
          }}
        </mat-slide-toggle>
      </div>
      <div
        *ngIf="flockWeekChartFilters.showPorphyrioBenchmark && hasPorphyrioCategories"
        class="spacing--margin-half-top"
      >
        <agr-summary-card
          [title]="
            'flock-overview.week-registrations.filters.chart-lines.porphyrio-benchmark' | translate
          "
        >
          <div>
            <div class="spacing--margin-bottom">
              <mat-label>{{
                'flock-overview.week-registrations.filters.labels.breed-category-name' | translate
              }}</mat-label>
              <mat-radio-group
                [ngModel]="flockWeekChartFilters?.breedCategoryName"
                (ngModelChange)="changeBreedCategoryNameFilter($event)"
              >
                <mat-radio-button
                  *ngFor="let porphyrioCategory of porphyrioCategories"
                  class="text--small"
                  color="primary"
                  [value]="porphyrioCategory.category"
                  [attr.data-test]="'chart-settings__breed-category-' + porphyrioCategory.category"
                >
                  {{
                    'flock-overview.week-registrations.filters.breed-categories.' +
                      porphyrioCategory.category | translate
                  }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="spacing--margin-bottom">
              <mat-label>{{
                'flock-overview.week-registrations.filters.labels.egg-marketing-standard'
                  | translate
              }}</mat-label>
              <mat-radio-group
                [ngModel]="flockWeekChartFilters?.eggMarketingStandard"
                (ngModelChange)="changeEggMarketingStandardFilter($event)"
              >
                <mat-radio-button
                  *ngFor="let eggMarketingStandard of porphyrioEggMarketingStandardsFound"
                  class="text--small"
                  color="primary"
                  [value]="eggMarketingStandard.standard"
                  [attr.data-test]="
                    'chart-settings__egg-marketing-standard-' + eggMarketingStandard.standard
                  "
                >
                  {{ eggMarketingStandard.standard }} -
                  {{
                    'flock-overview.week-registrations.filters.egg-marketing-standards.' +
                      eggMarketingStandard.standard | translate
                  }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="flex--column spacing--margin-negative-bottom">
              <mat-label class="spacing--margin-half-bottom">
                {{ 'flock-overview.week-registrations.filters.labels.breed-name' | translate }}
              </mat-label>
              <mat-form-field class="flex__child--auto">
                <mat-select
                  [hideSingleSelectionIndicator]="true"
                  placeholder="{{
                    'flock-overview.week-registrations.filters.labels.breed-name' | translate
                  }}"
                  [ngModel]="flockWeekChartFilters?.breedName"
                  (ngModelChange)="changeBreedNameFilter($event)"
                  data-test="chart-settings__breed-selector"
                >
                  <mat-option *ngFor="let breed of porphyrioBreeds" [value]="breed">
                    <span *ngIf="breed === 'Overall'">
                      {{ 'flock-overview.week-registrations.filters.breeds.Overall' | translate }}
                    </span>
                    <span *ngIf="breed !== 'Overall'">
                      {{ breed }}
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </agr-summary-card>
      </div>

      <div class="spacing--margin-top">
        <mat-slide-toggle
          [hideIcon]="true"
          color="primary"
          class="text--small"
          [checked]="flockWeekChartFilters.showOtherFlock"
          (change)="toggleShowValue('showOtherFlock', flockWeekChartFilters.showOtherFlock)"
          data-test="chart-settings__show-other-flock"
        >
          {{ 'flock-overview.week-registrations.filters.chart-lines.other-flock' | translate }}
        </mat-slide-toggle>
      </div>
      <div *ngIf="flockWeekChartFilters.showOtherFlock" class="spacing--margin-half-top">
        <agr-summary-card
          [title]="'flock-overview.week-registrations.filters.chart-lines.other-flock' | translate"
        >
          <div>
            <div
              *ngIf="flocksForAllLocations?.length > 0"
              class="flex--column spacing--margin-negative-bottom"
            >
              <mat-form-field class="flex__child--auto">
                <mat-select
                  [hideSingleSelectionIndicator]="true"
                  placeholder="{{
                    'flock-overview.week-registrations.filters.labels.other-flock-placeholder'
                      | translate
                  }}"
                  data-test="chart-settings__other-flock-selector"
                  [ngModel]="flockWeekChartFilters.selectedOtherFlockId"
                  (ngModelChange)="changeSelectedOtherFlockId($event)"
                >
                  <mat-option *ngFor="let flock of flocksForAllLocations" [value]="flock.id">
                    {{ flock.name }} -
                    {{
                      'flock-overview.week-registrations.filters.labels.selector-option-barn'
                        | translate
                    }}
                    {{ flock.arrival?.barn?.name }} -
                    {{ flock.arrival?.arrivalDate | agrDate: 'shortDate' }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </agr-summary-card>
      </div>
    </div>
  </div>
</agr-dialog>
